/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { transparent } = colors;

// Giữ đồng bộ với assets/theme/components/form/select.js — xem chú thích lý do ở file đó.
const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      padding: `${pxToRem(12)} ${pxToRem(32)} ${pxToRem(12)} ${pxToRem(12)} !important`,

      "&.MuiInputBase-inputSizeSmall": {
        padding: `${pxToRem(10)} ${pxToRem(32)} ${pxToRem(10)} ${pxToRem(12)} !important`,
      },

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      right: pxToRem(8),
    },
  },
};

export default select;
